<div [formGroup]="form()">
  <mat-form-field class="form-field" appearance="fill">
    @if (hasIcon()) {
      <mat-icon matPrefix [matTooltip]="getToolTipText()">{{ iconName() }}</mat-icon>
    }
    <mat-select [formControlName]="controlName()" [placeholder]="placeHolder()">
      @for (item of valueList; track item) {
        <mat-option [value]="item">
          {{ 'LOOKUP.' + item | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
